import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "./DatePicker";
import dayjs from "dayjs";
import { addItem } from "./itemApi";
import CloseIcon from "@mui/icons-material/Close";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import ControlledComponent from "./DatePicker";
import { TabCp } from "./tab";
import { ModalHeader } from "../../common/modalHeader";
import MultipleImageInput from "../../common/imgUploadMul";

const initialData = {
  cgst: "",
  discontinue: false,
  sgst: "",
  igst: "",
  hsnCode: "",
  barcode: "",
  productorService: false,
  displayToCustomer: true,
  rawMaterialValue: "",
  requiredTime: "",
  itemCode: "",
  ItemDescription: "",
  mrp: "",
  productNumber: "",
  productUniqueNumber: "",
  discription: "",
  Unit: "",
  Price: "",
  fromDate: dayjs(),
  status: "active",
  isCounterSalesItem: true,
  itemCategoryId: 0,
  MyBusinessId: 0,
  batchId: "",
  daysOfService: null,
  lotNumber: "",
  boxNumber: "",
  gst: 0.0,
  businessLineId: 0,
  franchiseItemMasterId: 0,
  maintainInventory: false,
  itemServiceTypeAssn: null,
  productorService: true,
  discount: false,
  inventoryAlarmValue: 0,
};

export default function AddItem({
  open,
  item,
  onSave,
  setOpen,
  setEditedItem,
}) {
  const [selectedImages, setSelectedImages] = useState([]);
  const [isLess, setshowLess] = useState(false);
  const [rawMaterial, setMaterial] = useState(false);
  const [itemData, setItemData] = useState(initialData);
  const [valueTab, setValueTab] = useState("Service");
  const fileInputRef = useRef(null);

  const isIGSTReadOnly = itemData.cgst && itemData.sgst;
  const isCGST_SGST_ReadOnly = itemData.igst;
  const onClose = () => {
    setItemData(initialData);
    setOpen(false);
  };

  const onChange = (key, value) => {
    setItemData((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    if (item && open) {
      console.log("Initializing form with item data:", item);

      // Initialize images array
      const arr = [];
      if (item.imagePath1)
        arr.push({ url: item.imagePath1, file: item.imagePath1 });
      if (item.imagePath2)
        arr.push({ url: item.imagePath2, file: item.imagePath2 });
      if (item.imagePath3)
        arr.push({ url: item.imagePath3, file: item.imagePath3 });
      if (item.imagePath4)
        arr.push({ url: item.imagePath4, file: item.imagePath4 });

      // Clean null values from item
      const cleanedItem = Object.fromEntries(
        Object.entries(item).map(([key, value]) => [
          key,
          value === "null" || value === null ? "" : value,
        ])
      );

      setMaterial(!!item.rawMaterialValue);
      setValueTab(item?.productorService === false ? "Product" : "Service");
      setSelectedImages(arr);

      setItemData({
        ...initialData,
        ...cleanedItem,
        fromDate: dayjs(item?.startDate || new Date()),
        ItemDescription: item?.itemDescription || "",
        Unit: item?.unit || "",
        Price: item?.price || "",
        File1: item.imagePath1 || "",
        File2: item.imagePath2 || "",
        File3: item.imagePath3 || "",
        File4: item.imagePath4 || "",
      });
    } else if (!open) {
      // Reset form when closing
      setItemData(initialData);
      setSelectedImages([]);
      setMaterial(false);
      setEditedItem(null);
    }
  }, [open, item]);

  const handleSubmit = () => {
    const { cgst, sgst, igst } = itemData;
 const cgstVal = parseFloat(cgst || 0);
 const sgstVal = parseFloat(sgst || 0);
 const igstVal = parseFloat(igst || 0);
    console.log("Submitting item data:", itemData);

    if (cgst && sgst && cgst !== sgst) {
      Swal.fire({
        icon: "error",
        text: "CGST and SGST must have equal % values",
        ...swalAlertPopProps,
      });
      return;
    }
    if ((cgstVal && !sgstVal) || (!cgstVal && sgstVal)) {
      Swal.fire({
        icon: "error",
        text: "Please enter both CGST and SGST values together.",
        ...swalAlertPopProps,
      });
      return;
    }
    // Prepare the payload
    const payload = {
      ...itemData,
      fromDate: dayjs(itemData.fromDate).format("YYYY-MM-DD"),
      Price: itemData.Price ? Number(itemData.Price) : 0,
      Status: itemData.Status || "active",
      cgst: parseFloat(itemData.cgst || 0),
      sgst: parseFloat(itemData.sgst || 0),
      igst: parseFloat(itemData.igst || 0),
      mrp: parseFloat(itemData.mrp || 0),
      rawMaterialValue: parseFloat(itemData.rawMaterialValue || 0),
    };

    // Clear image fields if no images selected
    if (selectedImages.length === 0) {
      payload.File1 = null;
      payload.File2 = null;
      payload.File3 = null;
      payload.File4 = null;
      payload.imagePath1 = null;
      payload.imagePath2 = null;
      payload.imagePath3 = null;
      payload.imagePath4 = null;
    } else {
      // Map selected images to payload
      selectedImages.forEach((ele, index) => {
        payload[`File${index + 1}`] = ele.file ? ele.file : ele.url;
      });
    }

    console.log("Final payload being sent:", payload);

    addItem(payload, itemData.id)
      .then((res) => {
        console.log("API response:", res);
        if (res.error) {
          Swal.fire({
            text: res.error.message || "Failed to save item",
            icon: "error",
            ...swalAlertPopProps,
          });
        } else {
          onSave?.();
          onClose();
        }
      })
      .catch((err) => {
        console.error("API error:", err);
        Swal.fire({
          text: err.message || "An error occurred",
          icon: "error",
          ...swalAlertPopProps,
        });
      });
  };

  return (
    // <Dialog open={open} fullWidth={true} maxWidth="xs" onClose={onClose}>
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "85%", md: "70%", lg: "60%", xl: "50%" },
          maxHeight: "90vh",
          overflowY: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // center modal
          borderRadius: "10px",
          boxShadow: 24,
        }}
      >
        <ModalHeader title="Service / Product Information" onClose={onClose} />
        <DialogContent sx={{ p: 2 }}>
          <TabCp
            value={valueTab}
            setValue={(tab) => {
              setValueTab(tab);
              onChange("productorService", tab === "Service");
            }}
          />
          <Divider
            sx={{
              borderColor: "#4E4E4E",
              borderBottomWidth: 1,
              marginTop: 2,
            }}
          />
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                label={
                  <span>
                    {`${valueTab} Name:`}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                fullWidth
                size="small"
                value={itemData.ItemDescription}
                onChange={(e) => onChange("ItemDescription", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel
                  sx={{
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  }}
                >
                  <span>
                    Unit: <span style={{ color: "red" }}>*</span>
                  </span>
                </InputLabel>
                <Select
                  value={itemData.Unit}
                  sx={{
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                    // Optional: height customization
                    // height: 40,
                  }}
                  onChange={(e) => onChange("Unit", e.target.value)}
                  label="Unit"
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{
                    style: {
                      // height: '40px',
                      // background:"yellow"
                    },
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                >
                  <MenuItem value="Nos">Nos</MenuItem>
                  <MenuItem value="Per Head">Per Head</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label={
                  <span>
                    MRP (₹): <span style={{ color: "red" }}>*</span>
                  </span>
                }
                fullWidth
                size="small"
                value={itemData.mrp}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                onChange={(e) => {
                  const onlyDigits = e.target.value.replace(/[^0-9]/g, "");
                  onChange("mrp", onlyDigits);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label={
                  <span>
                    Selling Price (₹) : <span style={{ color: "red" }}>*</span>
                  </span>
                }
                fullWidth
                size="small"
                value={itemData.Price}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                onChange={(e) => {
                  const onlyDigits = e.target.value.replace(/[^0-9]/g, "");
                  onChange("Price", onlyDigits);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label={`${valueTab} Code :`}
                fullWidth
                size="small"
                value={itemData.itemCode}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                onChange={(e) => onChange("itemCode", e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={
                  <span>
                    {`${valueTab} Description:`}{" "}
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </span>
                }
                fullWidth
                size="small"
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                value={itemData.discription}
                onChange={(e) => onChange("discription", e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                label="CGST(%) :"
                fullWidth
                size="small"
                value={itemData.cgst}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  readOnly: !!itemData.igst,
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                // InputProps={{}}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) onChange("cgst", val);
                }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                label="SGST(%) :"
                fullWidth
                size="small"
                value={itemData.sgst}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  readOnly: !!itemData.igst,
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                // InputProps={{}}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) onChange("sgst", val);
                }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                label="IGST(%) :"
                fullWidth
                size="small"
                value={itemData.igst}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  readOnly: !!itemData.cgst || !!itemData.sgst,
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                // InputProps={{  }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) onChange("igst", val);
                }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                label="HSN Code :"
                fullWidth
                size="small"
                value={itemData.hsnCode}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*$/.test(val)) onChange("hsnCode", val);
                }}
              />
            </Grid>

            {valueTab === "Service" && (
              <>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Barcode :"
                    fullWidth
                    size="small"
                    value={itemData.barcode}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    onChange={(e) => onChange("barcode", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Required Time in Minutes :"
                    fullWidth
                    size="small"
                    value={itemData.requiredTime}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    onChange={(e) => onChange("requiredTime", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <ControlledComponent
                    date={itemData.fromDate}
                    update={itemData?.id}
                    onChange={(date) => onChange("fromDate", date)}
                    isEdit={!!item}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column">
                    <Box display="flex" gap={1} alignItems="center">
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 500,
                          color: "#01008B",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Raw materials required for this service?
                      </Typography>
                      <Switch
                        checked={rawMaterial}
                        onChange={(e) => setMaterial(e.target.checked)}
                      />
                    </Box>
                    {rawMaterial && (
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ mt: 1 }}
                        label="Enter raw material amount..."
                        value={itemData.rawMaterialValue}
                        onChange={(e) =>
                          onChange("rawMaterialValue", e.target.value)
                        }
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column">
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 500,
                          color: "#01008B",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Maintain Inventory
                      </Typography>
                      <Switch
                        checked={itemData.maintainInventory}
                        onChange={(e) =>
                          onChange("maintainInventory", e.target.checked)
                        }
                      />
                    </Box>

                    {itemData.maintainInventory && (
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Enter Minimum stock alarm value"
                        value={itemData.inventoryAlarmValue}
                        onChange={(e) =>
                          onChange("inventoryAlarmValue", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 500, color: "#01008B" }}
                    >
                      Display to customer
                    </Typography>
                    <Switch
                      checked={itemData.displayToCustomer}
                      onChange={(e) =>
                        onChange("displayToCustomer", e.target.checked)
                      }
                    />
                  </Box>
                </Grid>
                {/* <Grid item xs={6} >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 500, color: "#01008B" }}
                    >
                      Active
                    </Typography>
                    <Switch
                      checked={itemData.status === "active"}
                      onChange={(e) =>
                        onChange(
                          "status",
                          e.target.checked ? "active" : "inactive"
                        )
                      }
                    />
                  </Box>
                </Grid> */}
              </>
            )}

            {valueTab === "Product" && (
              <>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Barcode :"
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    value={itemData.barcode}
                    onChange={(e) => onChange("barcode", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Product Number :"
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      style: {
                        // height: '40px',
                        // background:"yellow"
                      },
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    value={itemData.productNumber}
                    onChange={(e) => onChange("productNumber", e.target.value)}
                  />
                </Grid>
                {/*<Grid item xs={12} sm={4}>
                  <TextField
                    label="Product Unique Number :"
                    fullWidth
                    size="small"
                    value={itemData.productUniqueNumber}
                    onChange={(e) =>
                      onChange("productUniqueNumber", e.target.value)
                    }
                  />
                </Grid> */}
                {/*<Grid item xs={12} sm={4}>
                  <TextField
                    label="Batch ID :"
                    fullWidth
                    size="small"
                    value={itemData.batchId}
                    onChange={(e) => onChange("batchId", e.target.value)}
                  />
                </Grid> */}
                {/*<Grid item xs={12} sm={4}>
                  <TextField
                    label="LOT No. :"
                    fullWidth
                    size="small"
                    value={itemData.lotNumber}
                    onChange={(e) => onChange("lotNumber", e.target.value)}
                  />
                </Grid> */}
                {/*<Grid item xs={12} sm={4}>
                  <TextField
                    label="Box Number :"
                    fullWidth
                    size="small"
                    value={itemData.boxNumber}
                    onChange={(e) => onChange("boxNumber", e.target.value)}
                  />
                </Grid> */}
                <Grid item xs={12} sm={4}>
                  <Box display="flex" flexDirection="column">
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, color: "#01008B" }}
                      >
                        Maintain Inventory
                      </Typography>
                      <Switch
                        checked={itemData.maintainInventory}
                        onChange={(e) =>
                          onChange("maintainInventory", e.target.checked)
                        }
                      />
                    </Box>

                    {itemData.maintainInventory && (
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Enter Minimum stock alarm value"
                        value={itemData.inventoryAlarmValue}
                        onChange={(e) =>
                          onChange("inventoryAlarmValue", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 500, color: "#01008B" }}
                    >
                      Display to customer
                    </Typography>
                    <Switch
                      checked={itemData.displayToCustomer}
                      onChange={(e) =>
                        onChange("displayToCustomer", e.target.checked)
                      }
                    />
                  </Box>
                </Grid>

                {/*<Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 500, color: "#01008B" }}
                    >
                      Active
                    </Typography>
                    <Switch
                      checked={itemData.status === "active"}
                      onChange={(e) =>
                        onChange(
                          "status",
                          e.target.checked ? "active" : "inactive"
                        )
                      }
                    />
                  </Box>
                </Grid> */}
              </>
            )}

            <Grid item xs={12}>
              <MultipleImageInput
                selectedImages={selectedImages}
                setSelectedImages={setSelectedImages}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <Divider sx={{ borderColor: "#4E4E4E", borderBottomWidth: 1 }} />
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            sx={{ width: "60%" }}
            variant="contained"
            onClick={handleSubmit}
            disabled={
              !itemData.ItemDescription ||
              !itemData.mrp ||
              !itemData.Price ||
              !itemData.Unit
            }
          >
            {itemData.id ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Box>
    </Modal>
  );
}
